__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "emr-appointment-client";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@oceantech/oceantech-ui", "0.9.5-2", () => (Promise.all([__webpack_require__.e(5985), __webpack_require__.e(1724), __webpack_require__.e(2669), __webpack_require__.e(8412), __webpack_require__.e(1489), __webpack_require__.e(6122), __webpack_require__.e(5676), __webpack_require__.e(9438), __webpack_require__.e(4229), __webpack_require__.e(2269), __webpack_require__.e(4188), __webpack_require__.e(7171)]).then(() => (() => (__webpack_require__(8412))))));
			register("axios", "0.26.1", () => (__webpack_require__.e(4569).then(() => (() => (__webpack_require__(4569))))));
			register("formik", "2.2.9", () => (Promise.all([__webpack_require__.e(2506), __webpack_require__.e(6122)]).then(() => (() => (__webpack_require__(2506))))));
			register("react-dom", "18.0.0", () => (Promise.all([__webpack_require__.e(4164), __webpack_require__.e(6122)]).then(() => (() => (__webpack_require__(4164))))));
			register("react-intl", "5.25.1", () => (Promise.all([__webpack_require__.e(3610), __webpack_require__.e(6122), __webpack_require__.e(2110)]).then(() => (() => (__webpack_require__(3610))))));
			register("react-router-dom", "6.3.0", () => (Promise.all([__webpack_require__.e(390), __webpack_require__.e(6122), __webpack_require__.e(2269), __webpack_require__.e(1034)]).then(() => (() => (__webpack_require__(3504))))));
			register("react-router", "6.3.0", () => (Promise.all([__webpack_require__.e(390), __webpack_require__.e(6122), __webpack_require__.e(6064)]).then(() => (() => (__webpack_require__(819))))));
			register("react", "18.0.0", () => (__webpack_require__.e(2791).then(() => (() => (__webpack_require__(2791))))));
			initExternal(2271);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};